import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { useIntl, useSelector, useFeatureToggles } from '@grandvisionhq/state';
import { OrderCallToAction } from '../components/OrderCallToAction.js';

const OrderCallToActionContainer = ({ isStacked  })=>{
    const { getLabel  } = useIntl();
    const myAccountRoutes = useSelector(Selectors.getFormattedRoutes);
    const { routes: bloomreachRoutes  } = useBloomreachPageRoutes();
    const { isMyAccountEnabled  } = useFeatureToggles();
    const labels = React.useMemo(()=>({
            continueShopping: getLabel('cart.actions.goBack'),
            visitMyAccount: getLabel('account.menu.myAccount')
        })
    , [
        getLabel
    ]);
    var _root;
    const routes = React.useMemo(()=>{
        return {
            continueShopping: (_root = bloomreachRoutes.root) !== null && _root !== void 0 ? _root : '',
            visitMyAccount: isMyAccountEnabled ? myAccountRoutes === null || myAccountRoutes === void 0 ? void 0 : myAccountRoutes.orders : undefined
        };
    }, [
        bloomreachRoutes.root,
        isMyAccountEnabled,
        myAccountRoutes === null || myAccountRoutes === void 0 ? void 0 : myAccountRoutes.orders
    ]);
    return /*#__PURE__*/ React.createElement(OrderCallToAction, {
        labels: labels,
        isStacked: isStacked,
        routes: routes
    });
};

export { OrderCallToActionContainer };
//# sourceMappingURL=OrderCallToActionContainer.js.map
